import type { BadgeType } from '@octopus-do/octopus-storybook'

import {
  PLAN_AGENCY,
  PLAN_FREE,
  PRO_PLANS,
  TEAM_PLANS,
} from '@/constants/userSubscriptionPlans'

export const getBadgeType = (
  planType: string,
  expired?: boolean
): BadgeType => {
  if (expired) {
    return 'expired'
  }

  if (PRO_PLANS.includes(planType)) {
    return 'pro'
  }

  if (TEAM_PLANS.includes(planType)) {
    return 'team'
  }

  switch (planType) {
    case PLAN_FREE: {
      return 'free'
    }
    case PLAN_AGENCY: {
      return 'agency'
    }
    default: {
      return 'free'
    }
  }
}
